'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@web/molecules';
import {
  StyledDidYouKnowCard,
  TitleWrapper,
  ImageContainer,
  Title,
  Explanation,
} from './styles';

export const DidYouKnowCard = ({ image, title, explanation }) => (
  <StyledDidYouKnowCard>
    <TitleWrapper>
      <ImageContainer>
        <ResponsiveImage
          src={image.src}
          alt={image.alt}
          height={image.height}
          width={image.width}
        />
      </ImageContainer>
      <Title>{title}</Title>
    </TitleWrapper>
    <Explanation>{explanation}</Explanation>
  </StyledDidYouKnowCard>
);

DidYouKnowCard.displayName = 'DidYouKnowCard';
DidYouKnowCard.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
  }),
  title: PropTypes.string,
  explanation: PropTypes.string,
};
